import api from '@/services/api'

export default {
  state: {
    orcamentoSelecionado: {
      id: '',
      ano: '',
      ativo: false,
      dataInicialProposta: '',
      dataFinalProposta: '',
      dataInicialReformulacao: '',
      dataFinalReformulacao: '',
      periodoOrcamento: 0,
    },
  },

  mutations: {
    SET_ORCAMENTO_SELECIONADO(state, orcamento) {
      state.orcamentoSelecionado = {
        id: orcamento.id,
        ano: orcamento.ano,
        ativo: orcamento.ativo === '1',
        dataInicialProposta: orcamento.dataInicialProposta,
        dataFinalProposta: orcamento.dataFinalProposta,
        dataInicialReformulacao: orcamento.dataInicialReformulacao,
        dataFinalReformulacao: orcamento.dataFinalReformulacao,
        periodoOrcamento: orcamento.periodoOrcamento,
      }
    },
  },

  actions: {
    async saveOrcamento({ commit }, orcamento) {
      try {
        return await api.post('/orcamentos', orcamento)
      } catch (error) {
        throw error
      }
    },

    async getOrcamentos({ commit }) {
      try {
        const response = await api.get('/orcamentos')

        return response && response.data ? response.data : null
      } catch (error) {
        throw error
      }
    },

    async getOrcamento({ commit }, orcamentoId) {
      try {
        const response = await api.get(`/orcamentos/${orcamentoId}`)

        return response && response.data ? response.data : null
      } catch (error) {
        throw error
      }
    },

    async updateOrcamento({ commit }, orcamento) {
      try {
        return await api.put(`/orcamentos/${orcamento.id}`, orcamento)
      } catch (error) {
        throw error
      }
    },

    async activeOrcamento({ commit }, orcamentoId) {
      try {
        return await api.put(`/orcamentos/${orcamentoId}/active`)
      } catch (error) {
        throw error
      }
    },

    setOrcamentoSelecionado({ commit }, orcamento) {
      commit('SET_ORCAMENTO_SELECIONADO', orcamento)
    },
  },

  getters: {
    orcamentoSelecionado: (state) => state.orcamentoSelecionado,
  },
}
